import React from "react";

import Background from "../../../components/common/Background/Background";
import SplashNav from "../../Splash/sub-components/SplashNav";
import Hero from "../../../components/container/Hero/Hero";
import Content from "../../../components/container/Content/Content";
import Page from "../../../components/common/Page/Page";
import Breadcrumbs from "../../../components/common/Breadcrumbs/Breadcrumbs";
import * as UserSelectors from "../../../store/User/User.selector";
import { useSelector } from "../../../lib/hook/ReduxHooks";
import { StoreState } from "../../../store/RootReducer";
import { TextElement } from "../../../lib/util/LocaleUtils";
import { useLocation } from "../../../lib/hook/NavigationHooks";
import { LANDING_PAGE_URL } from "../../../lib/util/NavigationUtils";
import * as TreeUtils from "../../../lib/util/TreeUtils";
import HeroTitle from "../../../components/container/HeroTitle/HeroTitle";
import InfoOverlay from "../../../components/state/InfoOverlay/InfoOverlay";

export interface LegalPageProps {
	modal?: boolean;
	children?: React.ReactNode;
}

const createLegalPage = (
	id: string,
	title: TextElement,
	component: React.ReactNode,
	options?: { portal?: boolean },
) =>
	React.memo((props: LegalPageProps) => {
		const { modal, children } = props;

		const { loggedInUser } = useSelector((state: StoreState) => ({
			loggedInUser: UserSelectors.selectLoggedInUser(state),
		}));

		const location = useLocation();

		const tree = TreeUtils.createUniformTree(
			[
				{
					id: "/",
					path: LANDING_PAGE_URL,
					name: "Brightmile",
					children: [
						{
							id: "/privacy",
							path: "/privacy",
							name: "Privacy & Cookie Policy",
							children: [],
						},
					],
				},
			],
			"children",
			"id",
		);

		return (
			<Page id={id} className={"Legal"}>
				{!modal && <Background />}
				{!modal && !loggedInUser?.uid && (
					<SplashNav noInteraction={!options?.portal} />
				)}
				<Hero>
					<div className={"--column"}>
						{!modal && options?.portal && (
							<Breadcrumbs tree={tree} selected={location.pathname} />
						)}
						<HeroTitle>{title}</HeroTitle>
					</div>
				</Hero>
				<Content>
					<React.Suspense fallback={<InfoOverlay type={"loading"} />}>
						{component}
						{children}
					</React.Suspense>
				</Content>
			</Page>
		);
	});

export default createLegalPage;
